import styled from 'styled-components'

interface LinkContainerProps {
  color?: string
}

export const LinkContainer = styled.a<LinkContainerProps>`
  text-decoration: none;
  cursor: pointer;
  ${(props) => (props.color ? `color: ${props.color}` : null)}
`
